<template>
  <main class="content">
      <div class="row">
          <h1>
              Edit Partner Profile
           </h1>
      </div>
      <form novalidate v-on:submit.prevent="updatePartner" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

          <fieldset class="form--item">
              <label class="label" for="">
                  Partner name:
              </label>
              <div class="input_text" id="name">
                  <input name="" placeholder="Write a name" required v-model="partner.name" type="text" value=""/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Percentage of revenue shared:
              </label>
              <div class="input_text" id="revenueShare">
                  <input name="" required v-model="partner.revenueShare" placeholder="Define a percentage of revenue for each video of this partner" type="text" value=""/>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label for=""></label>
              <div class="row">
                  <button class="btn btn_green btn_half u-fleft u-mr1" type="submit">
                      Update
                  </button>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Stripe Account:
              </label>
              <div class="input_text" id="emailAddress">
                  <span v-if="stripeShowStatus" class="status">{{ stripeStatus }}</span>
                  <input name="" required v-model="stripeEmailTextField" :placeholder="stripeTextFieldPlaceholder" type="email" value="" :disabled="stripeShowUnlink" />
                  <button v-if="stripeShowInvite" class="btn btn_green" @click="inviteStripeAccount()" type="button">
                      INVITE
                  </button>
                  <button v-if="stripeShowUnlink" class="btn btn_red" @click="unlinkStripeAccount()" type="button">
                      {{ unlinkTitle }}
                  </button>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Delete partner:
              </label>
              <a class="btn btn_red btn_half u-fleft" @click="confirmToggle()">
                  Delete
              </a>
          </fieldset>

      </form>
      <confirm resource="partner" :visible.sync="alertVisible"></confirm>
      <ok resource="partner" resource-plural="partners" :visible.sync="okVisible"></ok>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as EditResource from '../../mixins/editResource.mixin';

import Confirm from '../Modals/modal_confirm';
import Ok from '../Modals/modal_ok';
import Loading from '../Loading.vue'
import Message from '../Message.vue'

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const STRIPE_TEXTFIELD_PLACEHOLDER = "Enter an email to send a Stripe Connect invitation"

export default {
  name: 'EditPartners',
  components: { Confirm, Ok, Loading, Message },
  mixins: [ValidateForm, EditResource],
  computed: {
      stripeTextFieldValid: function() {
          return emailRegex.test(this.stripeEmailTextField);
      },
      stripeTextFieldPlaceholder: function() {
          if (this.partner.stripe && this.partner.stripe.emailAddress) {
              return this.partner.stripe.emailAddress;
          }
          else {
              return STRIPE_TEXTFIELD_PLACEHOLDER
          }
      },
      stripeShowUnlink: function() {
          return this.partner.stripe && this.partner.stripe.emailAddress;
      },
      stripeShowInvite: function() {
          return !this.stripeShowUnlink && this.stripeEmailTextField && emailRegex.test(this.stripeEmailTextField);
      },
      stripeShowStatus: function() {
          return this.stripeStatus != null;
      },
      stripeStatus: function() {
          if (!this.partner.stripe || !this.partner.stripe.emailAddress) {
              return null
          }
          else if (this.partner.stripe) {
              if (this.partner.stripe.accountConnected) {
                  return "Connected"
              }
              else {
                  return "Invited"
              }
          }
      },
      unlinkTitle: function() {
          if (this.stripeStatus == "Invited") {
              return "Cancel invitation"
          }
          else {
              return "Unlink account"
          }
      }
  },
  data () {
    return {
      model: 'partner',
      resource: 'partners',
      parentResource: 'Partners',
      alertVisible: false,
      okVisible: false,
      partner: {
          stripe: {}
      },
      stripeEmailTextField: "",
      required_fields: [
        {'attribute': 'partner.name', 'message': 'Name is missing', 'id': 'name'},
        {'attribute': 'partner.revenueShare', 'message': 'Revenue share is missing', 'id': 'revenueShare'}
      ]
    }
  },
  mounted(){
    var self = this;
    this.fetchResource(this.$route.params.id, {}, {}, () => {
        self.updateStripeTextField();
    });
  },
  methods: {
    updatePartner(){
        let self = this;
        this.updateResource(this.$route.params.id, this.partner);
    },
    updateStripeTextField() {
        try {
            self.stripeEmailTextField = self.partner.stripe.emailAddress
        } catch(e) {
            self.stripeEmailTextField = ""
        }
    },
    inviteStripeAccount(){
        let self = this;
        let email = this.stripeEmailTextField;
        try {
            if (!email || !emailRegex.test(email)) {
                throw new Error("Email must be specified");
            }

            this.partner.stripe.emailAddress = email;
            this.updateResource(this.$route.params.id, this.partner, { preventRedirect: true }, () => {
                self.updateStripeTextField();
            });
        }
        catch (e) {
            self.errorMessage = e;
        }
    },
    unlinkStripeAccount() {
        this.partner.stripe = null;
        this.updateResource(this.$route.params.id, this.partner, { preventRedirect: true }, () => {
            this.stripeEmailTextField = "";
            self.updateStripeTextField();
        });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditPartners.vue?21917499